import ApiService from '@boServices/apiService';

class TagService extends ApiService {
    getTags() {
        return this.fetchWithHeaders('/api/v2/backoffice/tags', 'GET');
    }

    getTagsPaginated({ search = '', page = 1, perPage = 20 } = {}) {
        const params = new URLSearchParams({ page: String(page), perPage: String(perPage) });
        if (search) params.set('search', search);
        return this.fetchWithHeaders(`/api/v2/backoffice/tags?${params.toString()}`, 'GET');
    }

    getTag(id) {
        return this.fetchWithHeaders(`/api/v2/backoffice/tags/${id}`, 'GET');
    }

    createTag(payload) {
        return this.fetchWithHeaders('/api/v2/backoffice/tags', 'POST', {
            body: JSON.stringify(payload),
        });
    }

    updateTag(id, payload) {
        return this.fetchWithHeaders(`/api/v2/backoffice/tags/${id}`, 'PUT', {
            body: JSON.stringify(payload),
        });
    }

    deleteTag(id) {
        return this.fetchWithHeaders(`/api/v2/backoffice/tags/${id}`, 'DELETE');
    }
}

export default TagService;
